/* eslint-disable max-len */
import ReactGA from 'react-ga4';
import { useSelector } from 'react-redux';

import { GetCourseByUser } from '../services/courses';

export async function getStatusLessonByUser(idUser, idCourse, idTopic, idLesson) {
  const courseByUser = await GetCourseByUser(idUser, idCourse);
  const currentTopic = courseByUser.data[0].topicsByUser.filter((topic) => topic.idTopic === idTopic)[0];
  const currentLesson = currentTopic.lessonsByUser.filter((lesson) => lesson.idLesson === idLesson)[0];
  return currentLesson.completedLesson;
}

export function shortFullName() {
  const { infoUser } = useSelector((store) => store.login);
  const { fullName } = infoUser;
  const separate = fullName.split(' ');
  return separate[0];
}

export function setAnalytics(category, action) {
  ReactGA.event({
    category,
    action,
  });
}
